import React, { Component } from "react";
import Router from "next/router";
import { Formik, Field, Form } from "formik";
import { TextField } from "formik-material-ui";
import * as yup from "yup";
import {
  Divider,
  Typography,
} from "@material-ui/core";
import { firebase } from "~/src/api";
import * as ROUTES from "~/src/constants/routes";


import {
  AppWithAuthentication,
  Head,
  Layout,
  Card,
  Link,
  Banner,
  FormLayout,
  Button,
  Spacing,
} from "~/src/components/global";

const validationSchema = yup.object().shape({
  email: yup.string().email("Must be a valid email address")
    .required("Email address is required"),
  password: yup.string()
    .required("Password is required"),
});

class LogInPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  render() {
    return (
      <AppWithAuthentication>
        <Head
          title="Log in · Bolstr"
        />
        <Layout size="sm">
          <Card
            title="Log in"
            h1
            action={{
              label: "New to Bolstr? Sign up",
              href: ROUTES.SIGN_UP,
            }}
          >
            <Formik
              initialValues={{
                email: "",
                password: "",
              }}
              validationSchema={validationSchema}
              onSubmit={(values, { setSubmitting }) => {
                const { email, password } = values;

                firebase
                  .doSignInWithEmailAndPassword(email, password)
                  .then(() => {
                    Router.push(ROUTES.TEACHERS);
                  })
                  .catch((error) => {
                    this.setState({ error });
                    setSubmitting(false);
                  });
              }}
            >
              {({ isSubmitting }) => (
                <Form>
                  <FormLayout>
                    {this.state.error && <Banner status="danger">{this.state.error.message}</Banner>}
                    <Field
                      label="Email Address"
                      name="email"
                      component={TextField}
                      type="email"
                    />
                    <Field
                      label="Password"
                      name="password"
                      component={TextField}
                      type="password"
                    />
                    <FormLayout.Footer>
                      <Link href={ROUTES.HOME} unstyled>
                        <Button>Cancel</Button>
                      </Link>

                      <Button
                        color="primary"
                        loading={isSubmitting}
                        type="submit"
                      >
                        Log In
                      </Button>
                    </FormLayout.Footer>
                  </FormLayout>
                </Form>
              )}
            </Formik>

            <Spacing />
            <Divider />
            <Spacing />

            <Typography align="center">
              <Link href={ROUTES.FORGOT_PASSWORD}>Forgot your password?</Link>
            </Typography>
          </Card>
        </Layout>
      </AppWithAuthentication>
    );
  }
}

export default LogInPage;
